import Icon from '../components/Icon';

const Weather21Colored = Icon(
  'weather-21-colored',
  <>
    <path
      fill="#D0D6CE"
      d="M11.192 2C7.835 2 5.075 4.56 4.746 7.84A3.63 3.63 0 0 0 2 11.368 3.627 3.627 0 0 0 5.621 15h11.545C19.836 15 22 12.829 22 10.15s-2.164-4.849-4.834-4.849q-.165 0-.327.011A6.47 6.47 0 0 0 11.192 2M8 20.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zM15.25 18a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M6 17.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5z"
    />
  </>
);

export default Weather21Colored;
